module.exports = __webpack_public_path__ + "static/img/1-1.82b95eed.png";